import { Drawer } from '@reveni-io/reveni-ui'

import ManageVisibilityForm from './ManageVisibilityForm/ManageVisibilityForm'

const ManageVisibilityDrawer = ({
  show,
  onClose,
  onSave,
  saving,
  view,
  groups,
  ownGroupIds,
  canSelectGroups,
  loadingGroups,
}) => {
  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <ManageVisibilityForm
        view={view}
        groups={groups}
        ownGroupIds={ownGroupIds}
        canSelectGroups={canSelectGroups}
        loadingGroups={loadingGroups}
        saving={saving}
        onCancel={onClose}
        onSave={onSave}
      />
    </Drawer>
  )
}

export default ManageVisibilityDrawer
